module.exports = __webpack_public_path__ + "img/portugal-transport-accidents-male.f109dc56.png";